import { render, staticRenderFns } from "./RegionalQuestionaireQuestion.vue?vue&type=template&id=5f6148a3&"
import script from "./RegionalQuestionaireQuestion.vue?vue&type=script&lang=js&"
export * from "./RegionalQuestionaireQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RegionalQuestionaireQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports